import { defineMessages } from 'react-intl';

export default defineMessages({
  contactUs: {
    id: 'yield-management.schedule-list-v2.empty-state.contact-us',
    defaultMessage: 'Contact us',
  },
  integratedPastSubtitle: {
    id: 'yield-management.schedule-list-v2.empty-state.integrated-past-subtitle',
    defaultMessage:
      "You can't add classes to past dates. Review your upcoming schedule to ensure future dates remain bookable.",
  },
  integratedPastTitle: {
    id: 'yield-management.schedule-list-v2.empty-state.integrated-past-title',
    defaultMessage: 'No classes were scheduled on this date',
  },
  integratedTodayFutureSubtitle: {
    id: 'yield-management.schedule-list-v2.empty-state.integrated-today-future-subtitle',
    defaultMessage:
      'No synced classes found for the selected date. Check your booking software or contact us if something looks wrong.',
  },
  integratedTodayFutureTitle: {
    id: 'yield-management.schedule-list-v2.empty-state.integrated-today-future-title',
    defaultMessage: 'No classes found for this date',
  },
  integrationsUpsellSubtitle: {
    id: 'yield-management.schedule-list-v2.empty-state.integrations-upsell-subtitle',
    defaultMessage: '<link>Connect your booking software</link> to sync schedules automatically',
  },
  integrationsUpsellTitle: {
    id: 'yield-management.schedule-list-v2.empty-state.integrations-upsell-title',
    defaultMessage: 'Tired of adding classes manually?',
  },
  manageSchedule: {
    id: 'yield-management.schedule-list-v2.empty-state.manage-schedule',
    defaultMessage: 'Manage schedule',
  },
  manualPastSubtitle: {
    id: 'yield-management.schedule-list-v2.empty-state.manual-past-subtitle',
    defaultMessage:
      "You can't add classes to past dates. Review your upcoming schedule to ensure future dates remain bookable.",
  },
  manualPastTitle: {
    id: 'yield-management.schedule-list-v2.empty-state.manual-past-title',
    defaultMessage: 'No classes were scheduled on this date',
  },
  manualTodayFutureSubtitle: {
    id: 'yield-management.schedule-list-v2.empty-state.manual-today-future-subtitle',
    defaultMessage: 'Add classes to your schedule to make them bookable',
  },
  manualTodayFutureTitle: {
    id: 'yield-management.schedule-list-v2.empty-state.manual-today-future-title',
    defaultMessage: 'No classes are scheduled for this date',
  },
});
